import React from 'react';
import PostingElement from './PostingElement';
import Dialog from 'Components/Core/Dialog';
import Form from 'Components/Core/Form/Form';
import FormElement from 'Components/Core/Form/FormElement';
import FormSelectImage from 'Components/Core/Form/FormSelectImage';

export default function NewThreadShort(props) {

	const x = props.x;
	const instanceId = props.forumId || 'default';
	const wafId = "new-thread-short-" + instanceId;
	const fileRenameId = wafId + '-file-rename';
	const smiliesId = wafId + '-smilies';
	const smileyIconId = wafId + '-smiley-icon';
	const fileInputRef = React.useRef(null);
	const pendingFile = React.useRef(null);
	const pendingCursorPos = React.useRef(null);
	// Pfeil-Nach-Oben in leerem Composer-Feld bearbeitet den zuletzt eigenen
	// Beitrag im aktuellen Forum (analog Rocket.Chat) - editingPostingNo=null
	// bedeutet "kein Bearbeiten-Modus aktiv". editBackupRef haelt den
	// urspruenglichen Rohtext fuer die Historie (siehe PostingUpdate.inc) und
	// fuer den Escape-Abbruch.
	const [editingPostingNo, setEditingPostingNo] = React.useState(null);
	const editBackupRef = React.useRef('');

	React.useEffect(() => {

		// if (! x.was.isMobileDevice()) x.waf.focus('new-thread-short', 'posting');

		const handleKey = (event) => {
			if (event.target.id !== wafId + '-new-posting-short') return;

			if (event.key === '@') {
				const forumId = x.wam.getForumId();
				x.wam[forumId].showDialogNewThread();
				if (typeof x.wam[forumId].setTab === 'function') x.wam[forumId].setTab('postings');
				x.wam.activate(forumId);

				event.preventDefault();
				return;
			}

			// Pfeil-Nach-Oben in leerem Feld: letzten eigenen Beitrag zum Bearbeiten
			// laden (analog Rocket.Chat) - nur, wenn nicht schon editiert wird und
			// das Feld leer ist (sonst wuerde man versehentlich einen gerade
			// getippten Entwurf verlieren).
			if (event.key === 'ArrowUp' && editingPostingNo === null && x.waf.get(wafId, 'new-posting-short').trim() === '') {
				event.preventDefault();
				startEditLastPosting();
				return;
			}

			if (event.key === 'Escape' && editingPostingNo !== null) {
				event.preventDefault();
				cancelEdit();
			}
		}

		window.addEventListener("keydown", handleKey);


		return () => {
			window.removeEventListener("keydown", handleKey);
		}

	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props, x.was, x.wam, wafId, editingPostingNo]);

	React.useEffect(() => {
		if (x.was.windowWidth > 1000) {
			x.$('#' + wafId + '-new-posting-short').trigger("focus");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	React.useEffect(() => {
		x.wad[smiliesId + '-dialog'].onClose = () => {
			const composerInput = document.getElementById(wafId + '-new-posting-short');
			if (composerInput) composerInput.focus();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	function selectFile() {
		if (props.disabled) return;
		fileInputRef.current.click();
	}

	function splitFileName(name) {
		const dotPos = name.lastIndexOf('.');
		if (dotPos <= 0) return { base: name, extension: '' };
		return { base: name.substring(0, dotPos), extension: name.substring(dotPos) };
	}

	function uploadFile(event) {
		const file = event.target.files[0];
		event.target.value = '';
		if (!file) return;

		// Cursor-Position VOR dem Umschwenken auf den Umbenennen-Dialog sichern -
		// danach hat das Composer-Feld den Fokus (und damit die Selektion)
		// verloren, selectionStart waere dort nicht mehr verlaesslich.
		const inputEl = x.waf[wafId].elements['new-posting-short']?.reference?.current;
		pendingCursorPos.current = inputEl ? inputEl.selectionStart : null;

		// Bilder direkt mit dem Originalnamen hochladen, ohne Umbenennen-
		// Zwischenschritt - der Dateiname spielt fuer eingebettete Bilder keine
		// sichtbare Rolle (Wunsch mehrerer Mitglieder, der Dialog wurde als
		// unnoetige Bremse empfunden). Nur bei anderen Dateien (z.B. PDF), wo
		// der Name als Link-Text sichtbar bleibt, weiterhin nachfragen.
		if (isImageExtension(splitFileName(file.name).extension.replace('.', ''))) {
			performUpload(file, file.name);
			return;
		}

		pendingFile.current = file;
		x.waf.set(fileRenameId, 'filename', splitFileName(file.name).base);
		x.wad[fileRenameId].show(() => {
			x.waf.focus(fileRenameId, 'filename');
			x.waf.select(fileRenameId, 'filename');
		});
	}

	function confirmFileUpload(event) {
		event.preventDefault();
		const file = pendingFile.current;
		if (!file) return;

		const baseName = x.waf.get(fileRenameId, 'filename').trim();
		if (baseName === '') {
			x.wah.addHint('Bitte einen Dateinamen angeben.', true);
			return;
		}
		const fileName = baseName + splitFileName(file.name).extension;
		performUpload(file, fileName);
		x.wad[fileRenameId].hide();
		pendingFile.current = null;
	}

	function performUpload(file, fileName) {
		const formData = new FormData();
		formData.append('file', file, fileName);
		x.was.axPost('Backend/webapp.php?module=Posting&task=UploadFile', formData, (result) => {
			if (result.data.returncode === 1) {
				insertFileLink(result.data.content.fileName, result.data.content.displayName);
			}
			else {
				x.wah.addHint(uploadErrorMessage(result.data.returncode), false);
			}
		});
	}

	// Ordnet die spezifischen Fehler-Returncodes von Backend/UploadFile.inc einer
	// verstaendlichen Meldung zu, statt immer nur "Fehler beim Hochladen der Datei" zu zeigen.
	function uploadErrorMessage(returncode) {
		switch (returncode) {
			case -2:
				return 'Datei ist zu groß (maximal 20 MB erlaubt).';
			case -3:
				return 'Nur Bilddateien (JPG, PNG, GIF, WEBP) und PDF sind erlaubt. Der Dateiinhalt muss dabei zur Dateiendung passen.';
			default:
				return 'Fehler beim Hochladen der Datei.';
		}
	}

	// Bilddateien (siehe UploadFile.inc::ALLOWED_TYPES fuer die massgebliche
	// Liste) werden nicht als Link angehaengt, sondern direkt als [img][/img]
	// an der Cursor-Position eingefuegt - Wunsch mehrerer Mitglieder, die den
	// Umweg ueber den Link als unnoetig empfanden.
	function isImageExtension(extension) {
		return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension.toLowerCase());
	}

	function insertFileLink(fileName, displayName) {
		const target = 'new-posting-short';
		const extension = splitFileName(displayName).extension.replace('.', '');
		const curVal = x.waf.get(wafId, target);
		if (isImageExtension(extension)) {
			const tag = '[img]Backend/image.php?file=' + fileName + '[/img]';
			const pos = (pendingCursorPos.current !== null) ? pendingCursorPos.current : curVal.length;
			const leftValue = curVal.substring(0, pos);
			const rightValue = curVal.substring(pos);
			x.waf.set(wafId, target, leftValue + tag + rightValue);
		}
		else {
			const url = 'Backend/download.php?file=' + fileName + '&name=' + encodeURIComponent(displayName);
			const link = '[url=' + url + ']' + displayName + '[/url]';
			x.waf.set(wafId, target, curVal + (curVal.trim() > '' ? ' ' : '') + link);
		}
		pendingCursorPos.current = null;
		x.waf.focus(wafId, target);
	}

	function showSmilies(e) {
		if (props.disabled) return;
		x.waf[wafId][smiliesId].show(e, true);
	}

	function insertSmiley(event, key) {
		event.preventDefault();
		const target = 'new-posting-short';
		const inputEl = x.waf[wafId].elements[target].reference.current;
		const curPos = inputEl.selectionStart;
		const curVal = x.waf.get(wafId, target);
		const leftValue = curVal.substring(0, curPos);
		const rightValue = curVal.substring(curPos);
		const text = ':-' + key;
		x.waf.set(wafId, target, leftValue + text + rightValue);
		// Dialog bleibt offen, damit mehrere Smilies nacheinander ausgewaehlt
		// werden koennen; Fokus geht sonst verloren, da der Klick auf das
		// Icon/den Smiley ihn wegnimmt.
		const searchInput = document.getElementById(smiliesId);
		if (searchInput) searchInput.focus();
	}

	function makeSmilies(filter) {
		return x.wau.makeSmilies(filter, insertSmiley);
	}

	// Laedt den letzten eigenen Beitrag dieses Forums in den Composer zum
	// schnellen Korrigieren (Pfeil-Nach-Oben, siehe handleKey oben) - der
	// gesamte Text wird markiert, damit man ihn sofort komplett ueberschreiben
	// oder leeren kann.
	function startEditLastPosting() {
		const forumId = x.wam.getForumId();
		x.was.axGet('Backend/webapp.php?module=Posting&task=GetLastOwnPosting&forumId=' + forumId, (result) => {
			if (result.data.returncode !== 1) return;
			const posting = result.data.content.posting;
			editBackupRef.current = posting;
			setEditingPostingNo(result.data.content.postingno);
			x.waf.set(wafId, 'new-posting-short', posting);
			x.was.setNewThreadShortByWafId?.[wafId]?.(posting);
			x.waf.select(wafId, 'new-posting-short');
		});
	}

	function cancelEdit() {
		setEditingPostingNo(null);
		editBackupRef.current = '';
		x.waf.set(wafId, 'new-posting-short', '');
		x.was.setNewThreadShortByWafId?.[wafId]?.('');
		x.waf.focus(wafId, 'new-posting-short');
	}

	// Leerer Beitrag wird beim Speichern durch "*" ersetzt statt einen leeren
	// Beitrag abzuspeichern (Nutzervorgabe) - Historie/Update-Mechanik ist
	// identisch zur bestehenden Bearbeiten-Funktion (siehe NewAnswer.js::
	// postingSaveEdit, PostingUpdate.inc).
	function saveEditedPosting() {
		const value = x.waf.get(wafId, 'new-posting-short').trim();
		const posting = (value === '') ? '*' : value;
		const postingNo = editingPostingNo;
		const forumId = x.wam.getForumId();
		x.was.axPost('/Backend/webapp.php?module=Posting&task=PostingUpdate&postingNo=' + postingNo, {
			posting: posting,
			postingBackup: editBackupRef.current,
		}, (result) => {
			if (result.data.returncode === 1) {
				x.wam[forumId].reload();
				x.was.send('new-posting', { "module": forumId, "member": x.was.memberName, "memberlevel": x.was.memberLevel, "postingno": -1 });
			}
			else {
				x.wah.addHint('Bearbeiten fehlgeschlagen.', true);
			}
		});
		setEditingPostingNo(null);
		editBackupRef.current = '';
		x.waf.set(wafId, 'new-posting-short', '');
		x.was.setNewThreadShortByWafId?.[wafId]?.('');
	}

	function saveNewThread(event) {
		event.preventDefault();
		if (props.disabled) return;
		if (editingPostingNo !== null) {
			saveEditedPosting();
			return;
		}
		var forumId = props.forumId;
		if (!forumId) {
			if (x.wam.isForum()) {
				forumId = x.wam.current;
			}
			else {
				forumId = 'forum'
				x.wam.activate(forumId);
				// x.was.activateModule(forumId);
			}
		}
		const newThread = x.waf.get(wafId, 'new-posting-short');
		if (newThread.trim() > '') {
			x.wam[forumId].closeDialogs();
			// console.log('Save new Posting: ' + newThread);
			x.waf.set(forumId + '-new-thread', 'posting', newThread);
			x.waf[forumId + '-new-thread'].send();
			x.waf.set(wafId, 'new-posting-short', '');
			x.was.setNewThreadShortByWafId?.[wafId]?.('');
			x.waf.select(wafId, 'new-posting-short');
		}
	}

	/*
	async function newThreadFromClipboard() {
		const cb = await navigator.clipboard.read();
		const type = cb[0].types[0].substring(0, 4).toLowerCase();
		if (type === 'text') {
			const text = await navigator.clipboard.readText();
			pasteText(text);
		}
		if (type === 'image') {
			const text = await navigator.clipboard.readText();
			pasteText(text);
		}
	}
	*/

	return (
		<div id={wafId} className={` new-thread-short ${editingPostingNo !== null ? 'new-thread-short-editing' : ''}`}>
			{editingPostingNo !== null &&
				<React.Fragment>
					<span className="new-thread-short-editing-label" title="Esc: abbrechen, Enter: speichern, Shift+Enter: Zeilenumbruch">
						<i className="bi bi-pencil-fill"></i> Bearbeiten
					</span>
					<i
						className="bi bi-x-lg new-thread-short-icon new-thread-short-cancel-icon"
						title="Bearbeiten abbrechen"
						onClick={cancelEdit}
					></i>
				</React.Fragment>
			}
			<input
				type="file"
				ref={fileInputRef}
				style={{ display: 'none' }}
				onChange={uploadFile}
			/>
			{editingPostingNo === null &&
				<React.Fragment>
					<i className={`bi bi-paperclip new-thread-short-icon ${props.disabled ? 'new-thread-short-icon-disabled' : ''}`} title="Datei anhängen" onClick={selectFile}></i>
					<i id={smileyIconId} className={`bi bi-emoji-smile new-thread-short-icon ${props.disabled ? 'new-thread-short-icon-disabled' : ''}`} title="Smilies" onClick={showSmilies}></i>
				</React.Fragment>
			}
			<form className={`form-new-thread-short me-2`} onSubmit={e => saveNewThread(e)}>
				<PostingElement
					id="new-posting-short"
					x={x}
					wafId={wafId}
					classes="new-posting new-posting-short"
					maxLength="500"
					placeholder="Neuer Beitrag"
					onFocus={props.onFocus}
					onBlur={props.onBlur}
					onEnter={saveNewThread}
					disabled={props.disabled}
					autoComplete="off"
				/>
			</form>
			<FormSelectImage
				id={smiliesId}
				componentId={x.wau.getComponentId()}
				textMode={false}
				x={x}
				moduleId={props.forumId || 'default'}
				callId={smileyIconId}
				wafId={wafId}
				classes="select-smilies select-smilies-short"
				title="Smilies"
				alwayShowSelection={true}
				makeContent={makeSmilies}
				autoFocus={true}
			/>
			<Dialog id={fileRenameId} x={x} title="Datei hochladen" classes="dialog-file-rename">
				<Form
					x={x}
					wafId={fileRenameId}
					enableSendButton={true}
					sendButtonTitle="Hochladen"
					onSubmit={confirmFileUpload}
					focusElement="filename"
					classes="form-file-rename"
					checkChanged={() => { return true; }}
				>
					<FormElement
						type="text"
						x={x}
						wafId={fileRenameId}
						id="filename"
						mandatory={true}
						title=""
						placeholder="Dateiname"
						fieldValue=""
						maxLength="150"
					/>
				</Form>
			</Dialog>
		</div>
	);


}
